import { handleActions } from 'redux-actions';
import endpoints from '../../../config/endpoints';
import http from '../../shared/http';
import intl from '../../shared/intl';
import { formValueSelector, reset } from 'redux-form';
import { LOCATION_CHANGE } from 'react-router-redux';
import {getPartnerLandingUrl} from '../../../../shared/js/externalOfferHelpers';
import httpOnlyDomains from './../../../../shared/js/httpOnlyDomains';

import { REFETCH_ALL_DATA } from '../../root';

import moment from 'moment';

import cloneDeep from 'lodash/cloneDeep';
import map from 'lodash/map';
import find from 'lodash/find';
import filter from 'lodash/filter';
import isObject from 'lodash/isObject';
import uniqBy from 'lodash/uniqBy';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import qs from 'qs';

import { makeStatisticQuery } from '../functions';
import createFilters from '../../shared/filters';
import createCalendar from '../../shared/calendar';

const filters = createFilters({
	namespace: 'streams',
	stateNodeName: 'filters',
	filtersInitialState: [{
		title: 'Оффер',
		suggest: [{
			placeholder: 'Выберите оффер',
			key: 'offer_id',
			options: {
				source: 'streams.filtersOptions.offers',
				type: 'fromState'
			}
		}]
	}, {
		title: 'Язык',
		suggest: [{
			placeholder: 'Выберите язык',
			key: 'language',
			options: {
				source: 'streams.filtersOptions.languages',
				type: 'fromState'
			}
		}]
	}, {
		title: 'Источник трафика',
		suggest: [{
			placeholder: 'Выберите источник трафика',
			key: 'traffic_source',
			options: {
				source: 'streams.filtersOptions.trafficSources',
				type: 'fromState'
			}
		}]
	}].concat(process.env.CPA_ENV === 'rocket' ? [] : [{
		title: 'Валюта',
		suggest: [{
			placeholder: 'Выберите источник трафика',
			key: 'currency',
			options: {
				source: 'app.lists.payout-currencies',
				type: 'fromState'
			}
		}]
	}])
});

const calendar = createCalendar({
	namespace: 'streams',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment('2014-03-31').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

// initial state
const initialState = {
	data: null,
	campaignsWithoutConversions: [],
	error: null,
	shouldShowLinkBuilder: false,
	highlightedRowId: null,
	linkBuilderRow: null,
	linkBuilderOffer: null,
	shouldShowTestSuccess: false,
	shouldShowSplitSessions: false,
	splitSessionsRowId: null,
	splitSessionsRows: [],
	sids: {
		sid1: '',
		sid2: '',
		sid3: '',
		sid4: '',
		sid5: ''
	},
	filtersOptions: {
		languages: [],
		currencies: [],
		offers:[],
		dates: [],
		advSystems: [],
		trafficSources: []
	},
	pagination: {
		offset: 0,
		limit: 50,
		total_count: 0
	},
	showArchived: false,
	filters: filters.initialState,
	calendar: calendar.initialState,
	search: ''
};

// actions types
const FETCH_DATA_SUCCESS = 'streams/fetch-data-success';
const FETCH_DATA_ERROR = 'streams/fetch-data-error';

const FETCH_OFFER_FOR_STREAM_SUCCESS = 'streams/fetch-offer-for-stream-success';
const FETCH_OFFER_FOR_STREAM_ERROR = 'streams/fetch-offer-for-stream-error';
const SEND_TEST_CONVERSION_SUCCESS = 'streams/send-test-converion-success';
const SEND_TEST_CONVERSION_ERROR = 'streams/send-test-converion-error';
const SET_SHOULD_SHOW_TEST_CONVERSION = 'streams/set-should-show-test-conversion';

const SHOW_MORE_CAMPAIGNS_SUCCESS = 'streams/show-more-campaigns-success';

const FETCH_CAMPAIGNS_WITHOUT_CONVERSIONS_SUCCESS = 'streams/show-more-campaigns-without-conversions-success';

const DELETE_ITEM_SUCCESS = 'streams/delete-data-success';
const DELETE_ITEM_ERROR = 'streams/delete-data-error';

const DELETE_MULTIPLE_CAMPAIGNS_SUCCESS = 'streams/delete-multiple-campaigns-success';
const DELETE_MULTIPLE_CAMPAIGNS_ERROR = 'streams/delete-multiple-campaigns-error';

const CLONE_ITEM_SUCCESS = 'streams/clone-data-success';
const CLONE_ITEM_ERROR = 'streams/clone-data-error';

const TOGGLE_LINK_BUILDER = 'streams/toggle-link-builder';
const TOGGLE_POPUP_BUILDER = 'streams/toggle-split-sessions-popup';
const CHANGE_SID = 'streams/change-sid';

const FETCH_SPLIT_SESSIONS_DATA_SUCCESS = 'streams/fetch-split-sessions-data-success';
const FETCH_SPLIT_SESSIONS_DATA_ERROR = 'streams/fetch-split-sessions-data-success';

const CLEAR_ALL_FILTERS = 'streams/clear-all-filters';

const TOGGLE_SHOW_ARCHIVED = 'streams/toggle-show-archived';
const SET_SEARCH = 'streams/set-search';
const CLOSE_POP_UP = 'streams/close-pop-up';

// actions
export const actions = Object.assign({
	fetchData: () => (dispatch, getState) => {
		return dispatch(actions.fetchCampaignsList())
			.then(() => dispatch(actions.fetchCampaignsWithoutConversions()));

	},
	fetchCampaignsList: () => (dispatch, getState) => {
		const { app: { lists }, streams: { search, showArchived, pagination } } = getState();

		const query = qs.stringify({
			search: search || '',
			showArchived,
			...pagination
		});

		const request = http({
			url: `${endpoints.STREAMS.LIST}?${query}`,
			method: 'get',
			actions: [ FETCH_DATA_SUCCESS, FETCH_DATA_ERROR],
			addToResponse: {
				lists
			}
		});

		return request(dispatch);
	},
	fetchCampaignsBatch:  () => (dispatch, getState) => {
		const { streams: { search, showArchived, pagination } } = getState();

		const query = qs.stringify({
			search: search || '',
			showArchived,
			...pagination,
			offset: pagination.offset + pagination.limit
		});

		const request = http({
			url: `${endpoints.STREAMS.LIST}?${query}`,
			method: 'get',
			actions: [ SHOW_MORE_CAMPAIGNS_SUCCESS ],
			addToResponse: {
				offset: pagination.offset + pagination.limit
			}
		});

		return request(dispatch);
	},
	fetchCampaignsWithoutConversions: () => (dispatch, getState) => {
		const request = http({
			url: `${endpoints.STREAMS.LIST}?are_campaigns_without_conversions=true`,
			method: 'get',
			actions: [ FETCH_CAMPAIGNS_WITHOUT_CONVERSIONS_SUCCESS ]
		});

		return request(dispatch);
	},

	toggleLinkBuilder: (streamId = null) => (dispatch, getState) => {
		const streams = getState().streams.data;
		const stream = find(streams, it => it.id == streamId);

		if (stream) {
			const request = http({
				url: `${endpoints.OFFERS.LIST}/${stream.offer_id}`,
				method:'get',
				actions: [
					FETCH_OFFER_FOR_STREAM_SUCCESS,
					FETCH_OFFER_FOR_STREAM_ERROR
				]
			});
			request(dispatch);
		}

		dispatch(reset('linkBuilderForm'));
		dispatch({
			type: TOGGLE_LINK_BUILDER,
			payload: stream
		});

	},

	toggleSplitSessions: streamId => (dispatch, getState) => {
		if (streamId && !isObject(streamId)) {
			const streams = getState().streams.data;
			const stream = find(streams, it => it.id == streamId);
			const currency = stream && stream.currency;

			const request = http({
				url: endpoints.STREAM.SPLIT_SESSIONS.replace('{streamId}', streamId),
				method:'get',
				actions:[
					FETCH_SPLIT_SESSIONS_DATA_SUCCESS,
					FETCH_SPLIT_SESSIONS_DATA_ERROR
				],
				addToResponse: {
					streamId,
					currency
				}
			});

			request(dispatch).then(() => {
				dispatch({
					type: TOGGLE_POPUP_BUILDER,
					payload: streamId
				});
			});
		} else {
			dispatch({
				type: TOGGLE_POPUP_BUILDER,
				payload: 0
			});
		}
	},

	changeSid: (value) => ({
		type: CHANGE_SID,
		payload: value
	}),

	deleteItem: itemId => dispatch => {
		const request = http({
			url: endpoints.STREAMS.LIST + '/' + itemId,
			method: 'delete',
			actions: [
				DELETE_ITEM_SUCCESS,
				DELETE_ITEM_ERROR
			]
		});

		request(dispatch);
	},

	cloneCampaign: itemId => dispatch => {
		const request = http({
			url: endpoints.STREAMS.CLONE + '/' + itemId,
			method: 'post',
			actions: [
				CLONE_ITEM_SUCCESS,
				CLONE_ITEM_ERROR
			]
		});
		request(dispatch);
	},

	applySearch: val => dispatch => {
		const { streamsSearch } = val;
		dispatch({ type: SET_SEARCH, payload: streamsSearch });
		dispatch(actions.fetchCampaignsList());
	},

	clearAllFilters: () => dispatch => {
		dispatch(reset('filtersStreamsForm'));
		dispatch({ type: CLEAR_ALL_FILTERS });
	},

	sendTestConversion: () => (dispatch, getState) => {
		const state = getState();
		const linkRow = state.streams.linkBuilderRow;
		const linkBuilderForm = formValueSelector('linkBuilderForm');
		const selectedCountry = linkBuilderForm(state, 'country') || null;
		const sids = Object.keys(state.streams.sids).filter(sid => !!state.streams.sids[sid]);

		let data = { campaign_id: linkRow.id };

		if (selectedCountry) {
			data.country_code = selectedCountry.value;
		}

		forEach(sids, sid => {
			data[sid] = state.streams.sids[sid];
		});

		const request = http({
			url: endpoints.STREAMS.TEST_CONVERSION,
			method: 'post',
			data,
			actions: [
				SEND_TEST_CONVERSION_SUCCESS,
				SEND_TEST_CONVERSION_ERROR
			]
		});
		request(dispatch).then(action => {
			if (action.type == SEND_TEST_CONVERSION_SUCCESS) {
				dispatch({ type: SET_SHOULD_SHOW_TEST_CONVERSION, payload: true});
				setTimeout(() => {
					dispatch({ type: SET_SHOULD_SHOW_TEST_CONVERSION, payload: false});
				}, 2000);
			}
		});
	},

	toggleShowArchived: () => dispatch => {
		dispatch({ type: TOGGLE_SHOW_ARCHIVED });
		dispatch(actions.fetchCampaignsList());
	},

	closeCampaignsWithoutConversionsPopUp: (final) => dispatch => {
		localStorage.setItem('stream_alert_closed', final ? 'final' : moment().toISOString());
		dispatch({ type: CLOSE_POP_UP });
	},

	removeExpiredCampaigns: () => (dispatch, getState) => {
		const campaignsWithoutConversions = selectors.getCampaignsWithoutConversions(getState());
		const idsToBeRemoved = [].concat(...campaignsWithoutConversions.map(cwc => cwc.ids));

		const request = http({
			url: endpoints.STREAMS.LIST,
			method: 'delete',
			data: {ids: idsToBeRemoved},
			actions: [ DELETE_MULTIPLE_CAMPAIGNS_SUCCESS, DELETE_MULTIPLE_CAMPAIGNS_ERROR ]
		});
		return request(dispatch)
			.then((action) => {
				if (action.type === DELETE_MULTIPLE_CAMPAIGNS_SUCCESS) {
					actions.closeCampaignsWithoutConversionsPopUp(true)(dispatch);
					return dispatch(actions.fetchData());
				}
			});
	}
}, filters.actions, calendar.actions);

// reducers
const reducers = Object.assign({
	[LOCATION_CHANGE]: (state, action) => {
		if (action.payload.pathname.indexOf('/campaigns/') !== -1) {
			return initialState;
		}
		return state;
	},
	[FETCH_DATA_SUCCESS]: (state, action) => {
		const {filtersOptions} = state;
		const lists = action.meta.lists;

		const data = action.payload.data.map(r => ({
			...r,
			last_conversion_age: Math.floor(moment().diff(moment(r.last_conversion_date || r.created_at), 'months'))
		}));

		return {
			...state,
			data,
			pagination: {
				...state.pagination,
				total_count: data[0] && parseInt(data[0].total_count)
			},
			toggleFetchInProgress: false,
			filtersOptions: getFiltersOptions({
				data: action.payload.data,
				filtersOptions,
				lists
			})
		};
	},
	[SHOW_MORE_CAMPAIGNS_SUCCESS]: (state, action) => {

		const data = action.payload.data.map(r => ({
			...r,
			last_conversion_age: Math.floor(moment().diff(moment(r.last_conversion_date || r.created_at), 'months'))
		}));

		return {
			...state,
			data: [...state.data, ...data],
			pagination: {...state.pagination, offset: action.meta.offset}
		};
	},
	[FETCH_CAMPAIGNS_WITHOUT_CONVERSIONS_SUCCESS]: (state, action) => {
		const data = action.payload.data.map(r => ({
			...r,
			last_conversion_age: Math.floor(moment().diff(moment(r.last_conversion_date || r.created_at), 'months'))
		}));

		const campaignsWithoutConversions = {};
		const closedAt = localStorage.getItem('stream_alert_closed');
		if (!closedAt || closedAt !== 'final' && moment().diff(closedAt, 'days') >= 1) {
			for (const r of data) {
				if (!r.removed_at && !r.is_ignored_autoremove && r.last_conversion_age >= 3) {
					campaignsWithoutConversions[r.last_conversion_age] = campaignsWithoutConversions[r.last_conversion_age] || [];
					campaignsWithoutConversions[r.last_conversion_age].push(r.id);
				}
			}
		}

		return {
			...state,
			campaignsWithoutConversions: Object
				.keys(campaignsWithoutConversions)
				.sort()
				.map(k => ({
					months: k,
					ids: campaignsWithoutConversions[k]
				}))
		};
	},
	[FETCH_DATA_ERROR]: (state, action) => {
		return {...state, error: true};
		// show more
	},
	[FETCH_SPLIT_SESSIONS_DATA_SUCCESS]: (state, action) => {
		return {
			...state,
			splitSessionsRowId: action.meta && action.meta.streamId || null,
			splitSessionsRows: action.payload && map(action.payload.data, session => {
				let date_start = moment(session.created_at);
				let date_end = session.stopped_at ? moment(session.stopped_at) : moment();

				date_start.set({'hours': 0, 'minutes': 0, 'seconds': 0});
				date_end.set({'hours': 23, 'minutes': 59, 'seconds': 59});

				session.statisticQuery = makeStatisticQuery({
					currency: action.meta.currency,
					date_range: {
						start: date_start.format('YYYY-MM-DD HH:mm:ss.SSS'),
						end: date_end.format('YYYY-MM-DD HH:mm:ss.SSS')
					},
					filters: {
						session_ids: [{
							id: session.id,
							text: session.session_key
						}]
					},
					groups: ['landing', 'transit']
				});

				return session;
			}) || []
		};
	},
	[FETCH_OFFER_FOR_STREAM_SUCCESS]: (state, action) => {
		return {
			...state,
			linkBuilderOffer: action.payload.data
		};
	},
	[TOGGLE_LINK_BUILDER]: (state, action) => {
		return {
			...state,
			shouldShowLinkBuilder: !state.shouldShowLinkBuilder,
			linkBuilderRow: action.payload,
			sids: initialState.sids
		};
	},
	[TOGGLE_POPUP_BUILDER]: (state, action) => {
		return {
			...state,
			shouldShowSplitSessions: !state.shouldShowSplitSessions,
			splitSessionsRowId: action.payload && action.payload.streamId || null
		};
	},

	[CHANGE_SID]: (state, action) => {
		const {sidName, value} = action.payload;
		return {
			...state,
			sids: {
				...state.sids,
				[sidName]: value
			}
		};
	},

	// delete item
	[DELETE_ITEM_SUCCESS]: (state, action) => {
		return {...state, data: null};
	},
	[DELETE_ITEM_ERROR]: (state, action) => {
		return {...state, error: true};
	},

	// clone item
	[CLONE_ITEM_SUCCESS]: (state, action) => {
		const clonedCampaignId =  get(action, 'payload.data.id', null);
		return {
			...state,
			highlightedRowId: clonedCampaignId,
			data: null
		};
	},
	[CLONE_ITEM_ERROR]: (state, action) => {
		return {...state, error: true};
	},

	[REFETCH_ALL_DATA]: () => initialState,

	[CLEAR_ALL_FILTERS]: state => ({
		...state,
		data: null,
		search: '',
		showArchived: false,
		filters: initialState.filters,
		calendar: initialState.calendar
	}),

	[SET_SHOULD_SHOW_TEST_CONVERSION]: (state, action) => {
		return {
			...state,
			shouldShowTestSuccess: action.payload
		};
	},

	[TOGGLE_SHOW_ARCHIVED]: (state, action) => {
		return {
			...state,
			toggleFetchInProgress: true,
			showArchived: !state.showArchived
		};
	},

	[SET_SEARCH]: (state, action) => {
		return {
			...state,
			search: action.payload
		};
	},

	[CLOSE_POP_UP]: (state) => {
		return {
			...state,
			campaignsWithoutConversions: []
		};
	}
}, filters.reducers, calendar.reducers);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getShowArchived: state => state.streams.showArchived,
	getCampaignsWithoutConversions: state => state.streams.campaignsWithoutConversions,
	getData: state => state.streams.data,
	getPaginationParams: state => state.streams.pagination,
	getTableData: state => {
		const tableRows = state.streams.data && getTableRows(state);
		return {
			tableRows: tableRows,
			totalRows: tableRows ? tableRows.length : 0
		};
	},
	getLinkBuilderData: state => ({
		shouldShow: state.streams.shouldShowLinkBuilder,
		links: state.streams.data && getBuilderLinks(state, selectors.getTableData, intl(state)),
		geoOptions: state.streams.linkBuilderOffer && filterLocationsByPayouts(state.streams.linkBuilderOffer),
		shouldShowTestSuccess: state.streams.shouldShowTestSuccess,
		shouldDisableCountrySelect: Boolean(get(state, 'streams.linkBuilderOffer.external_integration'))
	}),
	getSplitSessionsData:  state => ({
		shouldShow: state.streams.shouldShowSplitSessions,
		rows: state.streams.splitSessionsRows,
		capmaign_id: state.streams.splitSessionsRowId
	}),
	getHighlightedRowId: state => state.streams.highlightedRowId,
	getFilters: state => filters.selectors.selectFilters(state => state.streams.filters, state => state)(state),
	getAppliedFilters: state => filters.selectors.appliedFilters(state),
	getCalendar: state => calendar.selectors.getCalendar(state => state.streams.calendar, state => state)(state),
	getIsToggleLoader : state => state.streams.toggleFetchInProgress || false,
	getError : state => state.streams.error,
	getIntl: state => intl(state)
};

const getTableRows = (state) => {
	const { data, filters } = state.streams;

	const selectedFilters = filters.reduce((acc, filter) => {
		Object.keys(filter.suggest).forEach(suggestKey => {
			const current = filter.suggest[suggestKey];
			acc[current.key] = current.appliedItems.map(entity => entity.id);
		});
		return acc;
	}, {});

	const { calendar } = state.streams;
	const { start, end } = calendar.value || calendar.defaultValue;

	return data.filter(row => {
		return selectByGlobalFilter(row, selectedFilters) &&
			moment(start).startOf('day') <= moment(row.created_at) &&
			moment(end).endOf('day') >= moment(row.created_at);
	}).sort((a, b) => a.updated_at < b.updated_at ? 1 : -1 );
};

const getBuilderLinks = (state, getTableDataSelector, intl) => {
	const result = [];
	const linkRow = state.streams.linkBuilderRow || {};

	const sids = Object.keys(state.streams.sids)
		.filter(sid => !!state.streams.sids[sid])
		.map(sid => `${sid}=${state.streams.sids[sid]}`);

	const linkBuilderForm = formValueSelector('linkBuilderForm');
	const selectedCountry = linkBuilderForm(state, 'country') || null;
	const countryParam = selectedCountry && `${sids.length ? '&' : ''}country_code=${selectedCountry.value}` || '';
	if (linkRow.landing_domain && linkRow.transit_domain) {
		const isHttp = httpOnlyDomains[process.env.CPA_ENV].some(
			domain => linkRow.landing_domain.includes(domain)
		) || linkRow.transit_domain_type !== 'internal';
		result.push({
			link: `${isHttp ? 'http' : 'https'}://${linkRow.transit_domain}<b>?${sids.join('&')}${countryParam}</b>`,
			title: intl('Ссылка транзитки'),
			type: 'transit'
		});
	}

	if (linkRow.landing_domain) {
		const isHttp = httpOnlyDomains[process.env.CPA_ENV].some(
			domain => linkRow.landing_domain.includes(domain)
		) || linkRow.landing_domain_type !== 'internal';
		result.push({
			link: `${isHttp ? 'http' : 'https'}://${linkRow.landing_domain}<b>?${sids.join('&')}${countryParam}</b>`,
			title: intl('Ссылка лендинга'),
			type: 'landing'
		});
	}

	if (linkRow.offer_external_integration) {
		const {baseUrl, queryString, delimiter} = getPartnerLandingUrl({
			campaignId: linkRow.id,
			externalIntegration: linkRow.offer_external_integration,
			useRedirect: linkRow.offer_use_redirect,
			offerDomain: linkRow.offer_domain,
			redirectDomain: linkRow.redirect_domain,
			sids: state.streams.sids
		});
		const sidsQuery = sids.length ? `&${sids.join('&')}` : '';
		result.push({
			link: `${baseUrl}${delimiter}<b>${queryString}${sidsQuery}${countryParam}</b>`,
			title: intl('Ссылка лендинга'),
			type: 'landing'
		});
		if (linkRow.offer_external_integration === 'online_payments') {
			const {baseUrl, queryString, delimiter} = getPartnerLandingUrl({
				campaignId: linkRow.id,
				externalIntegration: linkRow.offer_external_integration,
				useRedirect: linkRow.offer_use_redirect,
				offerDomain: linkRow.offer_domain,
				redirectDomain: linkRow.redirect_domain,
				sids: state.streams.sids,
				additionalParams: {basket: true}
			});
			result.push({
				link: `${baseUrl}${delimiter}<b>${queryString}${sidsQuery}${countryParam}</b>`,
				title: intl('Ссылка на корзину'),
				type: 'landing'
			});
		}
	}

	if (!linkRow.landing_domain && !linkRow.transit_domain && linkRow.url) {
		result.push({
			link: `${linkRow.url}<b>?${sids.join('&')}${countryParam}</b>`,
			title: intl('Ссылка')
		});
	}

	return result;
};

const getFiltersOptions = ({ data, filtersOptions, lists })  => {
	const result = {};
	const filtersConfig = cloneDeep(filtersOptions);
	const uniqById = entity => uniqBy(entity, 'id');
	const advSystemsList = lists['adv-systems'];

	const prepare = data.reduce((acc, value) => {
		acc.languages.push({
			id: value.language,
			text: value.language
		});

		acc.currencies.push({
			id: value.currency,
			text: value.currency
		});

		acc.offers.push({
			id: value.offer_id,
			text: value.offer
		});

		// adv systems
		const spaceId = value['space_id'];
		const spaceTitle = value['space_title'];
		const advSystem = value['adv_system'];

		acc.advSystems.push({
			id: advSystem === 'other' ? spaceId : advSystem,
			text: advSystem === 'other' ? spaceTitle : find(advSystemsList, { 'id':advSystem })['text']
		});

		// traffic source
		const trafficSource = value['traffic_source'];
		acc.trafficSources.push({
			id: trafficSource,
			text: trafficSource
		});

		return acc;

	}, filtersConfig);

	Object.keys(prepare).forEach(key => {
		result[key] = uniqById(prepare[key]);
	});

	return result;
};

const selectByGlobalFilter = (row, selectedFilters) => {
	const result =  Object.keys(selectedFilters).reduce((acc, filterKey) => {
		if (acc === false) return false;
		if (selectedFilters[filterKey].length === 0) return true;

		const filterValue = selectedFilters[filterKey];
		const predicate = (filterValue, rowValue) => filterValue.indexOf(rowValue) > -1;

		switch (filterKey) {
			case 'adv_system': {
				const rowNameForFilter = row[filterKey] === 'other' ? 'space_id' : filterKey;
				return predicate(filterValue, row[rowNameForFilter]);
			}
			default:
				return predicate(filterValue, row[filterKey]);
		}
	}, true);

	return result;
};

const filterLocationsByPayouts = offer => {
	const filtered = filter(offer.locations, l => {
		return !!find(offer.payouts, p => p.country_code == l.country_code);
	});
	return map(filtered, l => ({
		label: l.name,
		value: l.country_code
	}));
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/list/index.js